import React from 'react';
import Header from './Header';
import Footer from './Footer';
export default function SiteShell({children, contact}) { return <div className="bg-[#f7f7f2] min-h-screen"><Header contact={contact}/><main className="pt-[76px]">{children}</main><Footer contact={contact}/></div>; }
